import { CampaignsAndDiscountsFilter } from '@/scopes/search/search/pages/SearchPage/components/FiltersLegacy/CampaignsAndDiscountsFilter'

import { IntelligentFilter } from '@/scopes/search/search/pages/SearchPage/components/FiltersLegacy/IntelligentFilter'
import * as React from 'react'
import { styled } from 'styled-components'
import { AccomodationTypeFilter } from './AccomodationTypeFilter'
import { CollectionsFilter } from './CollectionsFilter'
import { CustomerRatingFilter } from './CustomerRatingFilter'
import { DealFilter } from './DealFilter'
import { DestinationFilter } from './DestinationFilter'
import { DistanceToInterestsFilter } from './DistanceToInterestsFilter'
import { FacilitiesFilter } from './FacilitiesFilter'
import { LastMinuteFilter } from './LastMinuteFilter'
import { MealPlanFilter } from './MealPlanFilter'
import { NumberOfRoomsFilter } from './NumberOfRoomsFilter'
import { PricePerPersonFilter } from './PricePerPersonFilter'
import { StarsFilter } from './StarsFilter'
import { TransportTypeFilter } from './TransportTypeFilter'
import { VacationTypeFilter } from './VacationTypeFilter'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export function FiltersLegacy() {
  return (
    <Wrapper>
      <IntelligentFilter />
      <DestinationFilter />
      <PricePerPersonFilter />
      <TransportTypeFilter />
      <AccomodationTypeFilter />
      <MealPlanFilter />
      <DealFilter />
      <CampaignsAndDiscountsFilter />
      <FacilitiesFilter />
      <StarsFilter />
      <DistanceToInterestsFilter />
      <CustomerRatingFilter />
      <VacationTypeFilter />
      <LastMinuteFilter />
      <NumberOfRoomsFilter />
      <CollectionsFilter />
    </Wrapper>
  )
}
